module.exports = __webpack_public_path__ + "img/car.4846fc18.png";